import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { Grid, Divider, Typography } from '@material-ui/core';
import { ToggleButtonGroup } from '@material-ui/lab';
import AdvancedSettingsFooter from '../../../components/KillshotGroups/AdvancedSettings/footer';
import { NormalStyledDarkToggleButton, SplitStyledToggleButton } from '../../../components/Common/ToggleButton';

const styles = makeStyles({
  toggleButtons: {
    width: '39px',
    height: '39px',
    fontSize: '14px',
    fontWeight: '400',
    textTransform: 'none',
  },
  toggleFirstButton: {
    width: '49px',
    height: '39px',
    fontSize: '14px',
    fontWeight: '400',
    textTransform: 'none',
  },
  textStyle: {
    fontSize: '14px',
    fontWeight: '400',
  },
});

const GroupAdvanceDiscounting = props => {
  const { handleMarketModalClose, handleGroupAttrEdit, pricingGroup } = props;
  const theme = useTheme();
  const classes = styles();
  const discountOptions = [
    { label: 'None', value: 0 },
    { label: '10%', value: 10 },
    { label: '11%', value: 11 },
    { label: '12%', value: 12 },
    { label: '13%', value: 13 },
    { label: '14%', value: 14 },
    { label: '15%', value: 15 },
  ];
  const [discountValue, setDiscountValue] = useState(0);

  const handleModalClose = () => {
    handleMarketModalClose();
  };

  const handleSetCriteria = () => {
    handleGroupAttrEdit('discount')(null, discountValue);
    handleMarketModalClose();
  };

  const handleOnChange = (event, newDiscount) => {
    if (newDiscount.length === 0) {
      setDiscountValue(discountValue);
      return;
    }
    setDiscountValue(newDiscount);
  };

  useEffect(() => {
    if (pricingGroup.discount) {
      setDiscountValue(Number(pricingGroup.discount));
    }
  }, [pricingGroup.discount]);

  return (
    <Grid container direction="column">
      <Grid item style={{ padding: '24px 24px 0px 24px' }}>
        <Grid container direction="column" spacing={1} style={{ minHeight: '530px' }}>
          <Grid item>
            <Typography className={classes.textStyle}>Please select the GameTime discount.</Typography>
          </Grid>
          <Grid item style={{ marginTop: '5px' }}>
            <ToggleButtonGroup value={discountValue} onChange={handleOnChange} exclusive style={{ width: '283px' }}>
              {discountOptions.map(item =>
                theme.palette.type === 'dark' ? (
                  <NormalStyledDarkToggleButton
                    className={
                      item.value === discountOptions[0].value ? classes.toggleFirstButton : classes.toggleButtons
                    }
                    value={item.value}
                  >
                    {item.label}
                  </NormalStyledDarkToggleButton>
                ) : (
                  <SplitStyledToggleButton
                    className={
                      item.value === discountOptions[0].value ? classes.toggleFirstButton : classes.toggleButtons
                    }
                    value={item.value}
                  >
                    {item.label}
                  </SplitStyledToggleButton>
                )
              )}
            </ToggleButtonGroup>
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ padding: '0px 24px 0px 24px' }}>
        <Grid container className={classes.footerMessage}>
          <Grid item xs={12}>
            <Typography className={classes.textStyle}>
              Please make sure to save the group after you SET CRITERIA in order for your selections to be saved.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Divider style={{ width: '100%', color: '#E9E9E9' }} />
      <Grid item style={{ padding: '0px 24px 24px 24px' }}>
        <AdvancedSettingsFooter handleModalClose={handleModalClose} handleSetCriteria={handleSetCriteria} />
      </Grid>
    </Grid>
  );
};

GroupAdvanceDiscounting.propTypes = {
  handleMarketModalClose: PropTypes.func.isRequired,
  handleGroupAttrEdit: PropTypes.func.isRequired,
  pricingGroup: PropTypes.object.isRequired,
};

export default GroupAdvanceDiscounting;
